/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

import {ÉµÉµdefineInjectable} from '../di/interface/defs';
import {SecurityContext} from './dom_security_schema';

/**
 * Sanitizer is used by the views to sanitize potentially dangerous values.
 *
 * @see [Sanitization and security contexts](best-practices/security#sanitization-and-security-contexts)
 *
 * @publicApi
 */
export abstract class Sanitizer {
  abstract sanitize(context: SecurityContext, value: {} | string | null): string | null;
  /** @nocollapse */
  static Éµprov = /** @pureOrBreakMyCode */ /* @__PURE__ */ ÉµÉµdefineInjectable({
    token: Sanitizer,
    providedIn: 'root',
    factory: () => null,
  });
}
